<template>
  <div>
    <ui-header :heading="$tc('models.building', 2)">
      <auth-checker :accessRoles="['SuperAdmin', 'CompanyAdmin']">
        <ui-link class="add_new_button" type="text" :route="{ name: 'buildings-create' }">{{
          `${$tc('actions.add_new', 1)} ${$tc('models.building')}`
        }}</ui-link>
 <ui-link type="text" @click="doMigrate">Migrer</ui-link>
      </auth-checker>
    </ui-header>
    <building-list :buildings="buildings" v-loading="loading"> </building-list>
  </div>
</template>

<script>
import UiHeader from '@/components/ui/UiHeader';
import UiLink from '@/components/ui/UiLink';
import BuildingList from '../components/BuildingList';
import AuthChecker from '../../auth/components/AuthChecker';
import { getBuildings, migrate } from '../api';

export default {
  data() {
    return {
      buildings: [],
      loading: false
    };
  },

  components: {
    UiHeader,
    UiLink,
    BuildingList,
    AuthChecker
  },

  methods: {
    async getBuildings() {
      this.loading = true;
      try {
        const buildings = await getBuildings();
        this.buildings = buildings.sort((a, b) => (a.name > b.name ? 1 : -1));
        this.loading = false;
      } catch (err) {
        this.loading = false;
        const msg = {
          message: this.$t('errors.load', {
            msg: this.$tc('models.building', 2)
          }),
          type: 'error'
        };
        this.$message(msg);
      }
    },

    async doMigrate() {
      this.loading = true;
      try {
        await migrate();
        await this.getBuildings();
      } catch (error) {
        this.loading = false;
      }
    }
  },

  created() {
    this.getBuildings();
  },

  mounted() {
    this.$store.commit('changeBreadcrumbs', [
      {name: "models.buildings", link: "/app/buildings/"}
    ]);
  },
};
</script>


<style scoped>
.add_new_button {
  background-color: white;
  border: solid 1px black;
  color: black;
}
</style>
